import styled from 'styled-components';
import theme from '../../theme';

export const Container = styled.div`
  background-color: ${theme.colors.cardB1};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
`;

export const Text = styled.h4`
  color: white;
  font-weight: bold;
`;

export const Logo = styled.img`
    margin-bottom: 50px;
    height: 100px;
`;
